var clubService = require('clubService'),
    formValidation = require('formValidation'),
    loader = require('loader'),
    cropperjs = require('cropper'),
    idealTextColor = require('idealTextColor');

var editClubInfo = (function() {

    var clubID = $('body').attr('data-club-id');

    var formValidation = function() {
        $('#club-information-form').validate({
            rules: {
                club_name: {
                    required: true
                },
                bio: {
                    maxlength: 3000
                }
            },
            submitHandler: function() {
                $('window').showLoader();
                getClubInfoValues();
            }
        });
    };


    var getClubInfoValues = function() {
        var item = {};
        item.clubId = clubID;
        item.clubName = $('#club_name').val();
        item.clubBio = $('#club_bio').val();
        item.clubAddressLine1 = $('#club_address_line1').val();
        item.clubAddressLine2 = $('#club_address_line2').val();
        item.clubAddressCity = $('#club_address_city').val();
        item.clubAddressPostcode = $('#club_address_postcode').val();
        item.clubAddressCountry = $('#club_location').val();
        item.clubAddressCountryCode = $('#club_location').find(':selected').attr('data-flag');

        var data = JSON.stringify(item);

        updateClubInfoService(data, successFn, errorFn);
    };


    var updateClubSocial = function() {
        $('#update-club-social-information').on('click', function(e) {
            e.preventDefault();
            $('window').showLoader();
            var item = {};
            item.club_id = clubID;
            item.club_website = $('#club_website').val();
            item.club_twitter = $('#club_facebook').val();
            item.club_facebook = $('#club_twitter').val();
            item.club_instagram = $('#club_instagram').val();

            var data = JSON.stringify(item);
            updateClubSocialService(data, successFn, errorFn);
        });
    };

    var updateClubColours = function() {
        $('#update-club-colour-information').on('click', function(e) {
            e.preventDefault();
            $('window').showLoader();

            var item = {};
            item.clubId = clubID;
            item.primary_colour = $('#primary-colours').val();
            item.secondary_colour = $('#secondary-colours').val();

            var data = JSON.stringify(item);
            updateClubColourService(data, successFn, errorFn);
        });
    };

    var clubBioCount = function() {
        if ($('#club_bio').length) {
            var elem = $('#counter');
            $('#club_bio').limiter(3000, elem);
        }
    };


    var populateCountrySelect = function() {
        var selectedCode = $('#club_location').attr('data-selected-flag');

        // Not ideal, but we need location-code-dropdown.js to have run before we can add the selected attribute
        function hasDropdownInit() {
            if ($('#club_location option').length > 1) {
                $('#club_location option[data-flag="' + selectedCode + '"]').attr('selected', true);
            } else {
                setTimeout(hasDropdownInit, 500);
            }
        }

        if (selectedCode) {
            hasDropdownInit();
        }
    };


    var successFn = function(response) {
        var url = null;
        if (response.statusCode === 200) {
            $('window').notification({title: response.message});
        } else {
            $('window').notification({title: response.message, error: true});
        }
    };


    var errorFn = function(response) {
        $('window').notification({title: 'Error 500 - cannot communicate with server', error: true});
    };


    var init = function() {
        formValidation();
        updateClubSocial();
        clubBioCount();
        updateClubColours();
        populateCountrySelect();
    };

    return {
        init: init
    };
})();

if ($('.edit-club-information-nav').length) {
    editClubInfo.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/edit-club.js